export default __webpack_public_path__ + "static/media/icons8-share.8dc46666.svg";